export { default } from './ErrorBoundary';
export { default as withErrorBoundary } from './withErrorBoundary';